/**
 * All Programs
 *
 * This component requires jQuery and Slick to function.
 * You can require it on the page using <div data-component="all-programs"></div>
 */

$( function() {
	$( '[data-component="all-programs"]' ).each( function() {
		let $holder = $( this );
     
		$( '.js-view-all', $holder ).on( 'click', function( e ) {
			e.preventDefault();
			$( this ).parent().hide();
			$( this ).parent().parent().find( '.all-programs__item' ).addClass( 'is-active' );
		} );

	} );
} );
